import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiaoseguanli",
  "use": "icon-jiaoseguanli-usage",
  "viewBox": "0 0 16 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 13\" id=\"icon-jiaoseguanli\"><path d=\"M5.792 0A4.054 4.054 0 019.84 3.854l.005.202a4.05 4.05 0 01-1.783 3.359 5.791 5.791 0 013.52 5.329h-1.158a4.633 4.633 0 00-9.267 0H0a5.793 5.793 0 013.52-5.33A4.054 4.054 0 015.79 0zm8.549 2.784a3.766 3.766 0 01-1.463 4.058 5.21 5.21 0 013.05 4.742h-1.159a4.054 4.054 0 00-3.852-4.049l-.202-.005V6.372a2.606 2.606 0 10-.687-5.123L9.724.131a3.765 3.765 0 014.617 2.653zM5.79 1.159a2.896 2.896 0 00-.02 5.792l.039-.001.158-.004a2.896 2.896 0 002.715-2.72l.005-.17a2.896 2.896 0 00-2.726-2.892l-.17-.005z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/jiaoseguanli.svg
// module id = 478
// module chunks = 4